
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const CompliancePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-50 to-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Compliance & Certifications
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Quality standards and regulatory compliance documentation for professional procurement
          </p>
        </div>
      </section>

      {/* Compliance Overview Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Quality & Safety Standards</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Manufacturing Quality</h3>
              <ul className="space-y-3 text-gray-700">
                <li>• ISO quality management systems</li>
                <li>• Manufacturing process controls</li>
                <li>• Component traceability</li>
                <li>• Quality assurance protocols</li>
              </ul>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Safety & Testing</h3>
              <ul className="space-y-3 text-gray-700">
                <li>• Electrical safety testing</li>
                <li>• Electromagnetic compatibility (EMC)</li>
                <li>• Material safety compliance</li>
                <li>• Optical safety considerations</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Applicable Certifications</h2>
          
          <div className="bg-white rounded-lg shadow-sm p-8">
            <p className="text-gray-600 mb-8">
              The following certifications and compliance items may apply by model and configuration:
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="border-l-4 border-teal-600 pl-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Quality Systems</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• ISO 9001 (Quality Management)</li>
                  <li>• ISO 13485 (Medical Devices)</li>
                  <li>• Manufacturing standards</li>
                </ul>
              </div>
              
              <div className="border-l-4 border-teal-600 pl-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Regional Compliance</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• CE marking (European Conformity)</li>
                  <li>• FCC compliance (US)</li>
                  <li>• Regional regulatory approvals</li>
                </ul>
              </div>
              
              <div className="border-l-4 border-teal-600 pl-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Environmental</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• RoHS compliance</li>
                  <li>• Environmental standards</li>
                  <li>• Material certifications</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Documentation Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Documentation Available</h2>
          
          <div className="bg-teal-50 border border-teal-200 rounded-lg p-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-6">Procurement Support Documentation</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Compliance Records</h4>
                <ul className="space-y-2 text-gray-700">
                  <li>• Certification copies</li>
                  <li>• Test reports and protocols</li>
                  <li>• Quality system documentation</li>
                  <li>• Safety assessment reports</li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Procurement Support</h4>
                <ul className="space-y-2 text-gray-700">
                  <li>• Technical specifications</li>
                  <li>• Installation requirements</li>
                  <li>• Service and warranty terms</li>
                  <li>• Training documentation</li>
                </ul>
              </div>
            </div>
            
            <div className="mt-8 p-6 bg-white rounded-lg">
              <p className="text-lg text-gray-900 font-semibold mb-4">
                Full documentation available upon request for credentialing, procurement, and compliance review.
              </p>
              <p className="text-gray-600">
                Contact our team to receive comprehensive compliance packets tailored to your facility's requirements and local regulations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-teal-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">Request Compliance Documentation</h2>
          <p className="text-xl text-teal-100 mb-8">
            Get complete compliance packets for your procurement and credentialing needs
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:info@novaradiancedist.com" 
              className="bg-white text-teal-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors duration-200 whitespace-nowrap"
            >
              Request Compliance Packet
            </a>
            <a 
              href="/contact" 
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors duration-200 whitespace-nowrap"
            >
              Contact Compliance Team
            </a>
          </div>
        </div>
      </section>

      {/* Disclaimer Section */}
      <section className="py-8 bg-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <p className="text-sm text-yellow-800">
              <strong>Important:</strong> Certifications and test reports vary by product model and configuration. 
              All compliance documentation is subject to verification and may differ based on specific product variants, 
              manufacturing dates, and applicable regulatory requirements. Contact our compliance team for model-specific documentation.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompliancePage;
